import { createAsyncThunk } from '@reduxjs/toolkit';

import { fetchAssignedTables, type FetchAssignedTablesParams } from '../../api/fetchers/assignedTables/fetcher';

interface FetchAssignedTablesActionParams extends FetchAssignedTablesParams {
  essential: boolean;
}

export const fetchAssignedTablesAction = createAsyncThunk(
  'assignedTables/fetchAssignedTables',
  (params: FetchAssignedTablesActionParams) => fetchAssignedTables(params)
);
